import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c1ed79d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LeftContentContainer" }
const _hoisted_2 = { class: "Content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "Header" }, "Welcome to Mastersportal", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Description" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "Text" }, "Get tailored updates on study programmes, top universities, and scholarships right in your inbox."),
  /*#__PURE__*/_createElementVNode("ul", { class: "Benefits" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Get personalised programme and university recommendations"),
    /*#__PURE__*/_createElementVNode("li", null, "Be the first to know about new scholarships and study opportunities")
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "ActionsContainer" }
const _hoisted_6 = { class: "MainActions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "JoinIncentiveContainer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//monet-prtl-co.imgix.net/Shared/Registration/optin_users.png",
    alt: "Join 4M+ students for study updates",
    class: "JoinIncentiveImage"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "JoinIncentiveText" }, "Join 4M+ students for study updates!")
], -1 /* HOISTED */))
const _hoisted_8 = { class: "InputContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Incentives = _resolveComponent("Incentives")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_Incentives, { class: "Incentives" })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "OptInButton",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
          }, "Get Personalised Updates"),
          _createElementVNode("button", {
            class: "NotificationSettings",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNotificationSettings && _ctx.openNotificationSettings(...args)))
          }, "Notification Settings")
        ])
      ]),
      _createElementVNode("button", {
        class: "OptOutButton",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.notNow && _ctx.notNow(...args)))
      }, "Not Now")
    ])
  ]))
}